module.exports = __webpack_public_path__ + "img/moderation_comment_sheet.cd7bec84.svg";